import { IDBPDatabase } from 'idb'

import asyncForEach from 'utils/asyncForEach'

import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Add `projectId` to the `keyPath` of all tables
 * - Added `actions` table
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v6---')

  const stores = ['tabs', 'sessions', 'scripts', 'models', 'fields', 'enums']
  const values: { [key: string]: any[] } = {}

  asyncForEach(
    stores,
    (storeName, next) => {
      const request = transaction.objectStore(storeName).getAll()
      request.onsuccess = () => {
        values[storeName] = request.result
        next()
      }
    },
    () => {
      asyncForEach(
        stores,
        (storeName, next) => {
          database.deleteObjectStore(storeName)
          database.createObjectStore(storeName, {
            keyPath: ['id', 'projectId'],
          })
          STUDIO_ENV_DEVELOPMENT &&
            console.log(`Added projectId to ${storeName} table keyPath`)

          const items = values[storeName]
          STUDIO_ENV_DEVELOPMENT &&
            console.log(
              `Repopulating ${storeName} with: `,
              JSON.stringify(items)
            )
          asyncForEach(
            items,
            (item, next) => {
              transaction.objectStore(storeName).put(item).onsuccess = next
            },
            () => next()
          )
        },
        () => {
          database.createObjectStore('actions', {
            keyPath: ['id', 'projectId'],
          })
          STUDIO_ENV_DEVELOPMENT && console.log('Created actions table')

          STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v6---')
          return next()
        }
      )
    }
  )
}
